import { CanDeactivateFn } from '@angular/router';
import { MyProfileComponent } from '@app/modals/my-profile/my-profile.component';
import { map } from 'rxjs';

export const hasUnsavedChanges: CanDeactivateFn<MyProfileComponent> = (component) => {
  return component.close().pipe(map(() => true));
};
